import sliderFirstImage from '../../media/Slider-image1.jpg'
import sliderSecondImage from '../../media/Slider-image-2.jpg'
import sliderThirdImage from '../../media/Slider-image-3.jpg'
import sliderFourthImage from '../../media/Slider-image-4.jpg'
import redBallLogo from '../../media/red-ball.png'

import '../../css/slider.css'

export default function Slider() {
  const slides = [
    {
      id: 1,
      image: sliderFourthImage,
      alt: 'Cricket stadium view',
      topHeading: 'MAVERICKSS',
      title: 'Team REDZod Battles Hard at NCCA Labor Day Tournament',
      description:
        'Our journey at the NCCA Labor Day Tournament was defined by relentless effort and unwavering team spirit. We fought for every inch, learned from every match, and represented REDZod with immense pride and heart.'
    },
    {
      id: 2,
      image: sliderFirstImage,
      alt: 'Cricket team celebrating',
      topHeading: 'MAVERICKSS',
      title: 'THE REDZOD CRICKET TEAM POWERED BY PRIDE & PURPOSE',
      description:
        'We learn from the field and the nets, then refine without compromise. When we say team, we mean you too; your innings shape our craft, and our craft lifts your innings.'
    },
    {
      id: 3,
      image: sliderSecondImage,
      alt: 'Cricket match action',
      topHeading: 'MAVERICKSS',
      title: 'MAVERICKS CRICKET TEAM. FEARLESS. MATCH-READY.',
      description:
        'Winning starts long before the toss. It begins in listening rooms, drafting tables, stitching floors, and dusty nets where we challenge every assumption.'
    },
    {
      id: 4,
      image: sliderThirdImage,
      alt: 'Cricket stadium view',
      topHeading: 'MAVERICKSS',
      title: 'Join the Cricketing Revolution with Mavericks Sports Foundation',
      description:
        'From friendly matches to intense competitions, our club offers an unforgettable cricket experience for players of all levels and ages.'
    }
  ]

  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-12 p-0'>
          <div id='mainCarousel' className='carousel slide' data-bs-ride='carousel'>
            {/* Indicators */}
            <div className='carousel-indicators'>
              {slides.map((slide, index) => (
                <button
                  key={slide.id}
                  type='button'
                  data-bs-target='#mainCarousel'
                  data-bs-slide-to={index}
                  className={index === 0 ? 'active' : ''}
                  aria-label={`Slide ${index + 1}`}
                />
              ))}
            </div>

            {/* Slides */}
            <div className='carousel-inner'>
              {slides.map((slide, index) => (
                <div key={slide.id} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                  <img
                    src={slide.image}
                    alt={slide.alt}
                    className='carousel-image d-block w-100'
                    style={{ objectFit: 'cover' }}
                  />
                  <div className='carousel-caption d-flex flex-column justify-content-center h-100'>
                    <div className='top-heading mb-2'>
                      <img
                        src={redBallLogo}
                        alt='Cricket ball'
                        className='me-2'
                        style={{ width: '30px' }}
                      />
                      <span className='fw-bold'>{slide.topHeading}</span>
                    </div>
                    <h1 className='text-light mb-3'>{slide.title}</h1>
                    <p className='text-white d-none d-md-block'>{slide.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Controls */}
            <button
              className='carousel-control-prev'
              type='button'
              data-bs-target='#mainCarousel'
              data-bs-slide='prev'
            >
              <span className='carousel-control-prev-icon' aria-hidden='true'></span>
              <span className='visually-hidden'>Previous</span>
            </button>
            <button
              className='carousel-control-next'
              type='button'
              data-bs-target='#mainCarousel'
              data-bs-slide='next'
            >
              <span className='carousel-control-next-icon' aria-hidden='true'></span>
              <span className='visually-hidden'>Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
